// kfe-audio-bar.js — bottom audio bar with play/pause/replay/scrubber.
//
// PORT TARGET: KFEAudioPlayerCombineControlView (iOS) and the AudioBar
// inside KFEProjectSetup.cs in the Unity port.

import { KFEComponent } from "../core/component.js";
import { html } from "../core/html.js";
import { audio } from "../core/audio-engine.js";

export class KFEAudioBar extends KFEComponent {
  static styles = `
    :host { display: flex; align-items: center; gap: 0.5rem;
            padding: 0.5rem 0.75rem; background: var(--kfe-surface);
            border-top: 1px solid var(--kfe-border); }
    button { padding: 0.4rem 0.7rem; border-radius: 6px; border: 1px solid var(--kfe-border);
             background: transparent; color: var(--kfe-fg); cursor: pointer; }
    .scrub { flex: 1; }
    time { font-variant-numeric: tabular-nums; color: var(--kfe-muted); font-size: 0.75rem; }
  `;

  onConnected() {
    const onTime = () => this._scheduleRender();
    audio.addEventListener("time", onTime);
    audio.addEventListener("ended", onTime);
    this.addCleanup(() => {
      audio.removeEventListener("time", onTime);
      audio.removeEventListener("ended", onTime);
    });
  }

  render() {
    const cur = audio.currentTime || 0;
    const dur = audio.duration || 0;
    return html`
      <button on:click=${() => audio.isPlaying ? audio.pause() : audio.resume()}>
        ${audio.isPlaying ? "⏸" : "▶"}
      </button>
      <button on:click=${() => audio.stop()}>↻</button>
      <input class="scrub" type="range" min="0" max=${String(Math.max(0.1, dur))} step="0.1" .value=${String(cur)}
             on:input=${(e) => audio.el.currentTime = Number(/** @type {HTMLInputElement} */ (e.target).value)} />
      <time>${fmt(cur)} / ${fmt(dur)}</time>
    `;
  }
}

/** @param {number} s */
function fmt(s) {
  if (!isFinite(s)) return "0:00";
  const m = Math.floor(s / 60);
  const r = Math.floor(s % 60).toString().padStart(2, "0");
  return `${m}:${r}`;
}
